import {_utils, observers} from "./utils/_utils.js";
import {_libs} from "./utils/_libs.js";
import {_state, getLocalState} from "./state/state.js";
import {sectionWithSwiper} from "./components/examples/section-with-swiper.js";
import {sectionWithGsap} from "./components/examples/section-with-gsap.js";

document.addEventListener('DOMContentLoaded', async (event) => {
    await Promise.all([
        _libs._lazyLoad(),
        getLocalState(),
        _libs._OverlayScrollbars(),
    ]);

    let isUserInteracted = true;
    _state.interactionEvents.forEach(event => {
        window.addEventListener(event, async () => {
            if (isUserInteracted) {
                isUserInteracted = false;
                await Promise.all([
                    _utils.initOnUserInteraction(),
                    _libs.initOnUserInteraction(),
                ])
                _state.updateState({isUserActive: true});
            }
        });
    });

    await Promise.all([
        _utils.init(),
        _libs.init(),
        observers.init(),

        sectionWithSwiper(),
        sectionWithGsap(),
    ]).then(async () => {
        await Promise.all([
            _utils.anchorInUrl(),
        ])
    });
});